var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 d-flex flex-column",attrs:{"id":("message-" + _vm.index)}},[_c('div',{class:['msg-entry p-2 rounded', {
      'align-self-start': _vm.sender === 0,
      'align-self-end': _vm.sender === 1
    }]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }